import { FC } from 'react'
import { Home } from './screens'
import searchIcon from './assets/search.png'
import globeIcon from './assets/globe.png'
import profileIcon from './assets/profile.svg'
import wheelchairIcon from './assets/wheelchair.png'
import shutdown from './assets/shut-down-svgrepo-com.svg'
import shutdownWhite from './assets/shutdown-white.svg'
import Login from './screens/login.screen/Login'
import General from "./stores/GeneralStore";

interface Route {
  key: string
  title?: string
  icon?: string
  path: string
  enabled: boolean
  component: FC<any>
  backgroundColor?: string
  textColor?: string
  width?: string,
  iconWhite?: string
}

export const routes: Array<Route> = [
  
  {
    key: 'home-route',
    title: 'Quick Pay',
    path: '/',
    enabled: true,
    component: Home,
    backgroundColor: '#62AA51'
  },
  {
    key: 'home-route-2',
    title: 'E-Token',
    path: '/',
    enabled: true,
    component: Home,
    backgroundColor: '#62AA51'
  },

]
export const loggedInRoutes: Array<Route> = [
  {
    key: 'home-route',
    title: 'Magdy Mohamed Morsy Mohamed',
    path: '/dashboard',
    enabled: true,
    component: Home,
    width: '20%',
    icon: profileIcon,
    iconWhite: profileIcon,
    backgroundColor: '#101E8E'
  },
  {
    key: 'logout-route',
    icon: shutdown,
    iconWhite: shutdownWhite,
    path: '/login',
    enabled: true,
    component: Login,
    backgroundColor:"white"
  }
]
